import { render, staticRenderFns } from "./MandatsOwn.vue?vue&type=template&id=5c75aa56&"
import script from "./MandatsOwn.vue?vue&type=script&lang=js&"
export * from "./MandatsOwn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports